import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { updateThemeConfig } from "../../actions";
import { formatName } from "./ThemeConfig";
import { Box, Grid, Input, Typography } from "@material-ui/core";

function TextComponent({...props}) {
    const [value, setValue] = useState(props.field.value);
    const dispatch = useDispatch();

    const handleInputChange = (e) => {
        setValue(e.target.value);
    };

    const handleInputBlur = () => {
        dispatch(updateThemeConfig(props.field.name, value));
    };

    return ( 
        <Box sx={{padding:'15px 0 !important'}}>
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <Typography>{formatName(props.field.name)}</Typography>
                </Grid>
                <Grid item xs={12}>
                    <Input 
                        style={{marginTop:'0', width:'100%', padding:'0 15px'}}
                        value={value}
                        onChange={handleInputChange}
                        onBlur={handleInputBlur}
                    />
                </Grid>
            </Grid>
        </Box>
     );
}

export default TextComponent;
